
import {packPromise} from "./index.js"
export default async function initSignalr(connection,cardInfo){
    await connection.stop()
    const [err, data] = await packPromise(connection.start());
    if (err) {
      return;
    }
    sigin(connection,cardInfo);
  }
  // 用户登录
  async function sigin(connection,cardInfo){
    console.log("sigin");
    connection.invoke(
      "sigin",
      JSON.stringify({
        Name: cardInfo.CardName,
        Id:cardInfo.IdNo, //身份证
        CardId: cardInfo.CardId,
        UserId: cardInfo.UserId,
        ConnectionId: connection.connectionId,
        Role: 0,
        InstitutionId:cardInfo.InstitutionId,
      })
    )
  }


// WEBPACK FOOTER //
// ./src/utils/signalr.js